import * as React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getTranslate } from 'react-localize-redux';
import { withStyles } from '@material-ui/core/styles';
import { bindActionCreators } from 'redux';

import { Typography } from '@material-ui/core';

import * as AuthStore from '../../../app/store/AuthStore';
import { ErrorMessage } from '../../../youwell-common/components';

const styles = theme => ({
    root: {
        margin: theme.spacing(2),
        border: theme.borders.normal,
        padding: theme.spacing(2),
    },
    text: {
        color: theme.colors.blue2,
    },
});

class ErrorDescription extends React.Component {
    render() {
        const {
            classes, translate, errorMessage,
        } = this.props;

        if (!errorMessage) {
            return null;
        }

        const description = translate(`errorDescriptions.${errorMessage}`, null, { onMissingTranslation: () => null });

        if (!description) {
            return (<ErrorMessage message={errorMessage} onClear={this.props.clearError} />);
        }

        return (
            <div className={classes.root}>
                <Typography className={classes.text}>
                    {description}
                </Typography>
            </div>
        );
    }
}

ErrorDescription.propTypes = {
    classes: PropTypes.object.isRequired,
    translate: PropTypes.func.isRequired,
    clearError: PropTypes.func.isRequired,
    errorMessage: PropTypes.string,
};

ErrorDescription.defaultProps = {
    errorMessage: null,
};

const mapStateToProps = state => ({
    translate: getTranslate(state.localize),
});

const mapDispatchToProps = dispatch => ({
    ...bindActionCreators(AuthStore.actionCreators, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(ErrorDescription));
